import { createContext } from "react";
import type { Language } from "./language.ts";

export const LanguageContext = createContext<Language>("en");
